import { render, staticRenderFns } from "./K-1-1-1_EDMlist_EDMCreate.vue?vue&type=template&id=6a5110ae&"
import script from "./K-1-1-1_EDMlist_EDMCreate.vue?vue&type=script&lang=js&"
export * from "./K-1-1-1_EDMlist_EDMCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
